<template>
  <!-- <el-table :data="data" style="width: 100%;" :row-class-name="tableRowClassName" max-height="660">
    <el-table-column label="序号" type="index" width="80">
    </el-table-column>
    <el-table-column prop="UserCode" label="客户代码">
    </el-table-column>
    <el-table-column prop="UserName" label="客户名称">
    </el-table-column>
    <el-table-column prop="IB" label="层级关系" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column prop="CloseProfit" label="平盈">
    </el-table-column>
    <el-table-column prop="Commission" label="手续费">
    </el-table-column>
  </el-table> -->
  <table class="table table-2-1" id="tableBody">
    <tbody v-show="tableData.ishow">
      <tr>
        <td style="text-align:center;padding-top:50px;">暂无数据</td>
      </tr>
    </tbody>
    <tbody v-show="!tableData.ishow" class="nonedsda">
      <tr>
        <td colspan="1">
          账户：
        </td>
        <td colspan="1">
          {{tableData.billData.UserName}}
        </td>
        <td colspan="12">
        </td>
      </tr>
      <tr>
        <td colspan="1">
          日期：
        </td>
        <td colspan="1">
          {{tableData.billData.TradingDay | datefmt("YYYY-MM-DD")}}
        </td>
        <td colspan="12">
        </td>
      </tr>
      <tr>
        <td style="width: 100%;position:relative;" colspan="14">
          资金状况
          <span style="float:right;position:absolute;right:30px;">币种：{{tableData.UserAccounts.CurrencyName}}</span>
        </td>
      </tr>
      <tr>
        <td style="width: 100%;" colspan="14">
          ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
        </td>
      </tr>
      <tr>
        <td colspan="1">
          上次结算：
        </td>
        <td colspan="11" style="text-align:left">
          {{tableData.UserAccounts.PreDeposit}}
        </td>
        <td colspan="1">
          手续费：
        </td>
        <td colspan="1">
          {{tableData.UserAccounts.Commission}}
        </td>
      </tr>
      <tr>
        <td colspan="1">
          出金：
        </td>
        <td colspan="11" style="text-align:left">
          {{tableData.UserAccounts.Withdraw}}
        </td>
        <td colspan="1">
          期末结存：
        </td>
        <td colspan="1">
          {{tableData.UserAccounts.CurrDeposit}}
        </td>
      </tr>
      <tr>
        <td colspan="1">
          入金：
        </td>
        <td colspan="11" style="text-align:left">
          {{tableData.UserAccounts.Deposit}}
        </td>
        <td colspan="1">
          保证金：
        </td>
        <td colspan="1">
          {{tableData.UserAccounts.CurrMargin}}
        </td>
      </tr>
      <tr>
        <td colspan="1">
          持仓盈亏：
        </td>
        <td colspan="11" style="text-align:left">
          {{tableData.UserAccounts.FloatingProfit}}
        </td>
        <td colspan="1">
          可用资金：
        </td>
        <td colspan="1">
          {{tableData.UserAccounts.CurrUse}}
        </td>
      </tr>
      <tr>
        <td colspan="1">
          平仓盈亏：
        </td>
        <td colspan="11" style="text-align:left">
          {{tableData.UserAccounts.CloseProfit}}
        </td>
        <td colspan="1">
          风险度：
        </td>
        <td colspan="1">
          {{tableData.UserAccounts.RiskRatio}}%
        </td>
      </tr>
      <!-- 持仓明细 -->
      <tr v-show="tableData.isShow1">
        <td style="width: 100%;" colspan="15">
          -----------------------------------------------------------------------------------------------------------------------------------------持仓明细-----------------------------------------------------------------------------------------------------------------------------------
        </td>
      </tr>
      <tr v-show="tableData.isShow1">
        <td>
          合约代码
        </td>
        <td colspan="2">
          交易所
        </td>
        <td colspan="2">
          开仓日期
        </td>
        <td colspan="2">
          买/卖
        </td>
        <td>
          手数
        </td>
        <td>
          开仓价
        </td>
        <td>
          结算价
        </td>
        <td>
          持仓盈亏
        </td>
        <td colspan="3">
          保证金
        </td>
      </tr>
      <tr v-for="(item,index) in tableData.billData.PositionDetails" :key="index" v-show="tableData.isShow1">
        <td>
          {{item.ContractNo}}
        </td>
        <td colspan="2">
          {{item.ExchangeName}}
        </td>
        <td colspan="2">
          {{item.PositionDateTime}}
        </td>
        <td colspan="2">
          {{item.Direction == 0 ? "无" : (item.Direction == 1 ? "买入" : "卖出")}}
        </td>
        <td>
          {{item.VolumeTotal}}
        </td>
        <td>
          {{item.Price}}
        </td>
        <td>
          {{item.LastPrice}}
        </td>
        <td>
          {{item.PositionProfit}}
        </td>
        <td colspan="3">
          {{item.Margin}}
        </td>
      </tr>
      <tr v-show="tableData.isShow1">
        <td>
          共计: {{tableData.itemCounts1}}
        </td>
        <td colspan="2">

        </td>
        <td colspan="2">

        </td>
        <td colspan="2">

        </td>
        <td>

        </td>
        <td>

        </td>
        <td>

        </td>
        <td>

        </td>
        <td colspan="3">

        </td>
      </tr>
      <!-- 持仓汇总 -->
      <tr v-show="tableData.isShow2">
        <td style="width: 100%;" colspan="14">
          -----------------------------------------------------------------------------------------------------------------------------------------持仓汇总-------------------------------------------------------------------------------------------------------------------------------------
        </td>
      </tr>
      <tr v-show="tableData.isShow2">
        <td>
          合约代码
        </td>
        <td colspan="2">
          持买量
        </td>
        <td colspan="2">
          持卖量
        </td>
        <td colspan="2">
          持买开仓均价
        </td>
        <td colspan="2">
          持卖开仓均价
        </td>
        <td>
          结算价
        </td>
        <td>
          持仓盈亏
        </td>
        <td colspan="3">
          保证金
        </td>
      </tr>
      <tr v-for="(item,index) in tableData.billData.PositionStatis" :key="index + 1000" v-show="tableData.isShow2">
        <td>
          {{item.ContractNo}}
        </td>
        <td colspan="2">
          {{item.HoldBuyVolume}}
        </td>
        <td colspan="2">
          {{item.HoldSaleVolume}}
        </td>
        <td colspan="2">
          {{item.HoldBuyPrice}}
          <!-- {{item.Direction == 0 ? "无" : (item.Direction == 1 ? "买入" : "卖出")}} -->
        </td>
        <td colspan="2">
          {{item.HoldSalePrice}}
        </td>
        <td>
          {{item.LastPrice}}
        </td>
        <td>
          {{item.PositionProfit}}
        </td>
        <td colspan="3">
          {{item.Margin}}
        </td>
      </tr>
      <tr v-show="tableData.isShow2">
        <td>
          共计: {{tableData.itemCounts2}}
        </td>
        <td colspan="2">

        </td>
        <td colspan="2">

        </td>
        <td colspan="2">

        </td>
        <td colspan="2">

        </td>

        <td>

        </td>
        <td>

        </td>
        <td colspan="3">

        </td>
      </tr>
      <!-- 成交明细 -->
      <tr v-show="tableData.isShow3">
        <td style="width: 100%;" colspan="14">
          -----------------------------------------------------------------------------------------------------------------------------------------成交明细-------------------------------------------------------------------------------------------------------------------------------------
        </td>
      </tr>
      <tr v-show="tableData.isShow3">
        <td>
          合约代码
        </td>
        <td colspan="2">
          交易所
        </td>
        <td colspan="2">
          成交日期
        </td>
        <td colspan="2">
          成交时间
        </td>
        <td>
          买/卖
        </td>
        <td>
          成交价
        </td>
        <td>
          手数
        </td>
        <td colspan="2">
          开平
        </td>
        <td>
          手续费
        </td>
        <td>
          成交编号
        </td>
      </tr>
      <tr v-for="(item,index) in tableData.billData.Trades" :key="index + 2000" v-show="tableData.isShow3">
        <td>
          {{item.ContractNo}}
        </td>
        <td colspan="2">
          {{item.ExchangeName}}
        </td>
        <td colspan="2">
          {{item.TradeDateTime | datefmt("YYYY-MM-DD")}}
        </td>
        <td colspan="2">
          {{item.TradeDateTime | datefmt("HH:mm:ss")}}
          <!-- {{item.Direction == 0 ? "无" : (item.Direction == 1 ? "买入" : "卖出")}} -->
        </td>
        <td>
          {{item.Direction == 0 ? "无" : (item.Direction == 1 ? "买入" : "卖出")}}
        </td>
        <td>
          {{item.Price}}
        </td>
        <td>
          {{item.Volume}}
        </td>
        <td colspan="2">
          {{item.PositionEffect == 0 ? "无" : (item.PositionEffect == 1 ? "开仓" : (item.PositionEffect == 2 ? "平仓" : "平开"))}}
        </td>
        <td>
          {{item.Commission}}
        </td>
        <td>
          {{item.LocalOrderNo}}
        </td>
      </tr>
      <tr v-show="tableData.isShow3">
        <td>
          共计: {{tableData.itemCounts3}}
        </td>
        <td colspan="2">

        </td>
        <td colspan="2">

        </td>
        <td colspan="2">

        </td>
        <td colspan="2">

        </td>

        <td>

        </td>
        <td>

        </td>
        <td colspan="3">

        </td>
      </tr>

      <!-- 平仓明细 -->
      <tr v-show="tableData.isShow4">
        <td style="width: 100%;" colspan="15">
          -----------------------------------------------------------------------------------------------------------------------------------------平仓明细-------------------------------------------------------------------------------------------------------------------------------------
        </td>
      </tr>
      <tr v-show="tableData.isShow4">
        <td>
          合约代码
        </td>
        <td colspan="2">
          成交日期
        </td>
        <td colspan="2">
          成交时间
        </td>
        <td colspan="2">
          买/卖
        </td>
        <td>
          开仓价
        </td>
        <td>
          平仓价
        </td>
        <td>
          手数
        </td>
        <td colspan="2">
          开平
        </td>
        <td>
          平仓盈亏
        </td>
        <td>
          成交编号
        </td>
      </tr>
      <tr v-for="(item,index) in tableData.billData.Trades" :key="index + 3000" v-show="tableData.isShow4">
        <td>
          {{item.ContractNo}}
        </td>
        <td colspan="2">
          {{item.TradeDateTime | datefmt("YYYY-MM-DD")}}
        </td>
        <td colspan="2">
          {{item.TradeDateTime | datefmt("HH:mm:ss")}}
          <!-- {{item.Direction == 0 ? "无" : (item.Direction == 1 ? "买入" : "卖出")}} -->
        </td>
        <td colspan="2">
          {{item.Direction == 0 ? "无" : (item.Direction == 1 ? "买入" : "卖出")}}
        </td>
        <td>
          {{item.OpenPrice}}
        </td>
        <td>
          {{item.Price}}
        </td>
        <td>
          {{item.Volume}}
        </td>
        <td colspan="2">
          {{item.PositionEffect == 0 ? "无" : (item.PositionEffect == 1 ? "开仓" : (item.PositionEffect == 2 ? "平仓" : "平开"))}}
        </td>
        <td>
          {{item.CloseProfit}}
        </td>
        <td>
          {{item.LocalOrderNo}}
        </td>
      </tr>
      <tr v-show="tableData.isShow4">
        <td>
          共计: {{tableData.itemCounts4}}
        </td>
        <td colspan="2">

        </td>
        <td colspan="2">

        </td>
        <td colspan="2">

        </td>
        <td colspan="2">

        </td>

        <td>

        </td>
        <td>

        </td>
        <td colspan="3">

        </td>
      </tr>
      <tr>
        <td style="width: 100%;" colspan="14">
          ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
        </td>
      </tr>
      <tr class="textlea">
        <td style="width: 100%;" colspan="15">
          &nbsp;
        </td>
      </tr>
      <tr class="textlea">
        <td style="width: 100%;" colspan="14">
          如果下一交易日开市前不提出书面异议，贵方视为确认。
        </td>
      </tr>
      <tr class="textlea">
        <td style="width: 100%;" colspan="15">
          &nbsp;
        </td>
      </tr>
      <tr class="textlea">
        <td style="width: 100%;" colspan="14">
          结算部盖章
        </td>
      </tr>
      <tr class="textlea">
        <td style="width: 100%;" colspan="15">
          &nbsp;
        </td>
      </tr>
      <tr class="textlea">
        <td style="width: 100%;" colspan="15">
          客户签字
        </td>
      </tr>

      <!-- 无用的占位置文字 -->
      <tr id="parrnenda">
        <td>
          合约代码
        </td>
        <td colspan="2">
          交易所
        </td>
        <td colspan="2">
          成交日期
        </td>
        <td colspan="2">
          成交时间
        </td>
        <td>
          买/卖
        </td>
        <td>
          成交价
        </td>
        <td>
          手数
        </td>
        <td colspan="2">
          开平
        </td>
        <td>
          手续费
        </td>
        <td>
          成交编号
        </td>
      </tr>

    </tbody>
  </table>

</template>

<script>
import EnumConfig from "../../../../assets/js/EnumConfig.js";
export default {
  // 结算单表格
  name: "mycapitalT",
  data() {
    return {
      dialogVisible: false,
      obj: {},
      loading: ""
    };
  },
  props: ["tableData"],
  filters: {
    GetDelegateOrderStateType(type) {
      return EnumConfig.GetDelegateOrderStateType(type);
    },
    GetDirection(type) {
      return EnumConfig.GetDirection(type);
    },
    PositionEffect(type) {
      return EnumConfig.PositionEffect(type);
    }
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    handleClick(row) {
      this.dialogVisible = true;
      this.obj = row;
    }
  }
};
</script>

<style lang="less" scoped>
#tableBody {
  padding-bottom: 10px;
  .nonedsda {
    tr,
    td {
      // text-align: left;
      text-align: center;
      border-bottom: 0px !important;
      // border-right: 1px solid #000;
    }
  }
}
#parrnenda {
  td {
    color: rgba(0, 0, 0, 0);
  }
}
.textlea {
  td {
    text-align: left !important;
    padding-left: 70px;
  }
}
</style>
 


// WEBPACK FOOTER //
// src/components/selects/statics/StatisticsProfit/StatisticsProfitT.vue